<div class="row">
    <div class="col-12 text-center italic">
        <i>En cours de chargement</i>
    </div>
</div>